module.exports = __webpack_public_path__ + "img/4.f6cb0064.png";